import {
  RetentionMetrics as RetentionMetricsApi,
  ListSubscriptionRetentionByGroupResponseSubscriptionRetentionByGroup as RetentionMetricsByGroupApi,
} from '@vendasta/billing';

export interface RetentionMetrics {
  sku: string;
  productName: string;
  startingCount: number;
  activations: number;
  deactivations: number;
  churn: number;
  retention: number;
}

export interface RetentionMetricsByGroup {
  groupID: string;
  metrics: RetentionMetrics[];
}

export interface ListSubscriptionRetentionFilters {
  start?: Date;
  end?: Date;
}

export function subscriptionMetricFromAPI(mApi: RetentionMetricsApi): RetentionMetrics {
  return {
    sku: mApi.sku || '',
    productName: mApi.productName || '',
    startingCount: mApi.startingCount || 0,
    activations: mApi.activations || 0,
    deactivations: mApi.deactivations || 0,
    churn: mApi.churn || 0.0,
    retention: mApi.retention || 0.0,
  };
}

export function subscriptionMetricByGroupFromAPI(mApi: RetentionMetricsByGroupApi): RetentionMetricsByGroup {
  const metrics = (mApi.subscriptionMetrics || []).map((metric) => subscriptionMetricFromAPI(metric));
  return {
    groupID: mApi.groupId || '',
    metrics: metrics || [],
  };
}
